import {
  getESysName,
  SiteAllowStringValues,
} from "@inrange/building-manager-api-client/models-site";
import { Col, Form } from "react-bootstrap";

interface ESysSelectProps {
  site: SiteAllowStringValues;
  selectedEsysIdx: string;
  setSelectedEsysIdx: (value: string) => void;
  showWholeSiteOption?: boolean;
  wholeSiteLabel?: string;
  label?: string;
  colSize?: number;
  controlId?: string;
}

const ESysSelect = ({
  site,
  selectedEsysIdx,
  setSelectedEsysIdx,
  showWholeSiteOption = false,
  wholeSiteLabel = "Whole site",
  label = "Energy match",
  colSize = 3,
  controlId = "esys-select",
}: ESysSelectProps) => {
  const esysCount = Object.values(site.esys).filter((m) => !!m).length;

  if (esysCount <= 1) return null;

  return (
    <Col sm={colSize}>
      <Form.Group controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <Form.Select
          value={selectedEsysIdx}
          onChange={(e) => setSelectedEsysIdx(e.target.value)}
        >
          {showWholeSiteOption && <option value="">{wholeSiteLabel}</option>}
          {Object.values(site.esys)
            .filter((m) => !!m)
            .map((esys) => (
              <option key={esys.idx} value={esys.idx}>
                Energy match {getESysName(esysCount, esys)}
              </option>
            ))}
        </Form.Select>
      </Form.Group>
    </Col>
  );
};

export default ESysSelect;
